<template>
  <div v-if="plan" class="account-cards__item">
    <div class="account__heading">
      {{ $t('account.subscription.title') }}
    </div>
    <div class="account-block">
      <span class="account__subtitle">
        {{ $t('subscription.plans.planType') }}
      </span>
      <span v-if="!plan.editorAccess" class="account__text">{{
        $t('subscription.plans.noPlan')
      }}</span>
      <span v-else-if="plan.editorAccess" class="account__text">{{
        $t(`subscription.plans.${plan.type}`)
      }}</span>
    </div>
    <div class="account__link">
      <a v-if="account && account.stripeCustomerId" @click="launchCustomerPortal">{{
        $t('actions.changePlan')
      }}</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import paymentsService from '@/services/payments.service';

export default {
  name: 'CardPlans',
  computed: {
    ...mapState({
      account: (state) => state.distributors.distributorData,
      plan: (state) => state.subscriptions.planData
    })
  },

  methods: {
    async launchCustomerPortal() {
      try {
        const referrer = this.$route.query.referrer ? atob(this.$route.query.referrer) : null;
        const { data: session } = await paymentsService.createCustomerPortalSession(
          this.account.stripeCustomerId,
          referrer
        );
        window.top.location.href = session.url;
        return session;
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>
